import {layoutMarkup} from "../layout/layoutMarkup.js";
import {componentsHelper} from "../../helpers/componentsHelper.js";
import {layoutPublicMarkup} from "../layout/layoutPublicMarkup";
import l10n from '../../../lang/locallang';

const gallerySection = (param, is_public = false) => {
    let gallery = '';
    param.style = param.style ? param.style : '';
    param.layout = param['@layout'] ? param['@layout'] : 'gallery4';
    param.section = 'gallerySection';
    let layout_var = 'images-in-row images-row-4';
    let sectionClass = 'editor-section';
    switch (param.layout) {
        case 'gallery4':
            layout_var = 'images-in-row images-row-4';
            break;
        case 'gallery3':
            layout_var = 'images-in-row images-row-3';
            break;
        case 'gallery2':
            layout_var = 'images-in-row images-row-2';
            break;
        default:
            break;
    }
    param.class = param.class ? param.class : sectionClass;
    let list = {
        '0': {
            'id': 1,
            'asset_id': componentsHelper.setAssetUniqueID(null, 1, param.id, 'image'),
            'src': '../../images/editor/CG_106081553.jpeg',
            'alt': 'Alt image text',
            'caption': '',
        },
        '1': {
            'id': 2,
            'asset_id': componentsHelper.setAssetUniqueID(null, 2, param.id, 'image'),
            'src': '../../images/editor/CG_213876431.jpeg',
            'alt': 'Alt image text',
            'caption': '',
        },
        '2': {
            'id': 3,
            'asset_id': componentsHelper.setAssetUniqueID(null, 3, param.id, 'image'),
            'src': '../../images/editor/CG_11785224.jpeg',
            'alt': 'Alt image text',
            'caption': '',
        },
        '3': {
            'id': 4,
            'asset_id': componentsHelper.setAssetUniqueID(null, 4, param.id, 'image'),
            'src': '../../images/editor/CG_618865333.jpeg',
            'alt': 'Alt image text',
            'caption': '',
        }
    };

    // if exists param.content.gallery
    if(param.content) {
        list = param.content.gallery ? param.content.gallery : list;
    }
    const { edit, remove, addNewImage, enterCaption } = l10n.editor;

    let isAddImageBtnShow = false;
    switch (param.layout) {
        case 'gallery4':
            isAddImageBtnShow = list.length < 4;
            break;
        case 'gallery3':
            isAddImageBtnShow = list.length < 3;
            break;
        case 'gallery2':
            isAddImageBtnShow = list.length < 2;
            break;
        default:
            break;
    }

    for(let i in list){
        if (list.hasOwnProperty(i)) {
            let item = list[i];
            item.alt = item.alt ? item.alt : '';
            item.caption = item.caption ? item.caption : '';
            // createGalleryItem
            let galleryItem = document.createElement('div');
            galleryItem.classList.add('gallery-item');
            galleryItem.setAttribute('data-id', item.id);
            galleryItem.innerHTML = `
                ${!is_public ? `
                <div class="img-content-controls gallery-item-control">
                    <button class="btn gallery-img-button-edit" data-hint="${edit}"><i class="icon icon-img_upload"></i></button>
                    <button class="btn gallery-img-button-delete" data-hint="${remove}"><i class="icon icon-trash"></i></button>
                </div>
                ` : ''}
                <figure>
                    <a href="${item.src}" data-gallery>
                        <img src="${item.src}" alt="${item.alt}" data-asset-id="${item.asset_id}">
                    </a>
                    <figcaption ${!is_public ? `contenteditable="true" placeholder="${enterCaption}"` : ''}>${item.caption}</figcaption>
                </figure>`;
            gallery += galleryItem.outerHTML;
        }
    }

    param.component = `
        <div class="gallery-editor">
            <div class="gallery-wrapper ${layout_var}">
                ${gallery}
            </div>
        </div>
        ${!is_public ? `
        <div class="add-e-element-btn-wr ${isAddImageBtnShow ? '' : 'is-hidden'}">
            <button class="btn add-e-element-btn add-gallery-image"><i class="icon icon-add"></i><span>${addNewImage}</span></button>
        </div>`
        : ''}`;
    if(is_public){
        return layoutPublicMarkup(param);
    } else {
        return layoutMarkup(param);
    }
}

export {gallerySection};
